import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import useAppModal from 'hooks/useAppModal';
import { SystemTemplates } from 'models/automation/SystemTemplates';
import SystemTemplateEditModal from './SystemTemplateEditModal';

export const SYSTEM_TEMPLATE_EDIT_MODAL_ID = 'system-template-edit-modal';

const useSystemTemplatesEditModal = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openModal } = useAppModal();
  const navigateBack = () => navigate('../');

  const openSystemTemplateEditModal = ({ key }: { key: SystemTemplates }) => {
    openModal({
      customContent: (
        <SystemTemplateEditModal
          closeModal={navigateBack}
          systemTemplateKey={key}
        />
      ),
      id: SYSTEM_TEMPLATE_EDIT_MODAL_ID,
      title: t('pageAutomations.systemTemplates.modal.title'),
      onHide: navigateBack,
      closeOnHide: false,
    });
  };

  return { openSystemTemplateEditModal };
};

export default useSystemTemplatesEditModal;
